import {GetListAPICommand} from '@drl/core/core.module';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {environment} from '@drl/env/environment';

export class GetPatientsCommand<T> extends GetListAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>) {
    super(apiService, adapter, `${environment.userApiUrl}/users?care-group-specific=false`);
  }
}
